module.exports = __webpack_public_path__ + "img/LS20130822_greenfire_017.e4d9b227.jpg";